<template>
  <div>
    <loader :loading="loading"></loader>
    <div class="row">
      <div class="col-md-6 mb-4">
        <h2>Add User</h2>
        <p>This was my next new feature for development using a wizard.
          The wizard would have contained 3 steps:
          <ol>
            <li>User info</li>
            <li>User Roles</li>
            <li>Summary and confirmation screen</li>
          </ol>

          In the meantime, this is a quick and dirty form to add users to the system if need be:
        </p>
      </div>
    </div>
    <div v-if="errorMessage.length" class="row">
      <div class="col-md-8">
        <base-alert class="text-center" type="danger" v-html="errorMessage"></base-alert>
      </div>
    </div>
    <validation-observer v-slot="{ handleSubmit }" ref="user">
      <form @submit.prevent="handleSubmit(addUser)">
        <div class="row">
          <div class="col-md-3">
            <validation-provider rules="requiredUsername" v-slot="{ errors }">
              <base-input
                label="Username"
                addon-left-icon="tim-icons icon-single-02"
                :error="errors[0]"
                v-model="username">
              </base-input>
            </validation-provider>
          </div>
          <div class="col-md-5">
            <validation-provider :rules ="{ email: true, requiredEmail: true }" v-slot="{ errors }">
              <base-input
                label="Email"
                type="email"
                addon-left-icon="tim-icons icon-email-85"
                :error="errors[0]"
                v-model="email">
              </base-input>
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <validation-provider :rules ="{ requiredPassword: true }" v-slot="{ errors }" vid="confirmation">
              <base-input
                label="Password"
                type="password"
                placeholder="Password"
                addon-left-icon="tim-icons icon-lock-circle"
                :error="errors[0]"
                v-model="newPassword">
              </base-input>
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider :rules ="{ requiredPassword: true, passwordConfirmed: { target: 'confirmation'} }" v-slot="{ errors, untouched }">
              <base-input
                label="Confirm Password"
                type="password"
                placeholder="Confirm Password"
                addon-left-icon="tim-icons icon-lock-circle"
                :error="errors[0]"
                v-model="newPassword2">
              </base-input>
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 form-group">
            <label>Role</label>
            <el-select
              class="select-primary"
              size="large"
              placeholder="Single Select"
              v-model="role">
              <el-option v-for="r in roles" :key="r.id"
                class="select-primary"
                :value="r.name"
                :label="r.name">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mt-3">
            <base-button native-type="submit" type="primary" class="mb-3">
              Create User
            </base-button>
          </div>
        </div>
      </form>
    </validation-observer>

    <div class="row d-flex justify-content-center">
      <div class="col-md-10">
        <!--
        <simple-wizard @wizard-complete="wizardComplete">
          <template slot="header">
            <h3 class="card-title">Build your profile</h3>
            <h3 class="description">
              This information will let us know more about you.
            </h3>
          </template>

          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label">
              <i class="tim-icons icon-single-02"></i>
              <p>About</p>
            </template>
            <first-step
              ref="step1"
              @on-validated="onStepValidated"
            ></first-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
              <p>Account</p>
            </template>
            <second-step
              ref="step2"
              @on-validated="onStepValidated"
            ></second-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step3')">
            <template slot="label">
              <i class="tim-icons icon-delivery-fast"></i>
              <p>Address</p>
            </template>
            <third-step
              ref="step3"
              @on-validated="onStepValidated"
            ></third-step>
          </wizard-tab>
        </simple-wizard>
        -->
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { BaseAlert } from 'src/components';
  import { Select, Option } from 'element-ui';
  //import { SimpleWizard, WizardTab } from 'src/components';
  //import FirstStep from './UserWizard/FirstStep.vue';
  //import SecondStep from './UserWizard/SecondStep.vue';
  //import ThirdStep from './UserWizard/ThirdStep.vue';
  import swal from 'sweetalert2';
  import { addAdminUser, getRoles } from 'src/modules/adminActions';

  export default {
    components: {
      Loader,
      [Option.name]: Option,
      [Select.name]: Select,
      ValidationObserver,
      ValidationProvider,
      BaseAlert
      //FirstStep,
      //SecondStep,
      //ThirdStep,
      //SimpleWizard,
      //WizardTab
    },
    data() {
      return {
        username: null,
        email: null,
        newPassword: null,
        newPassword2: null,
        role: 'analyst',
        errorMessage: '',
        loading: false,
        roles: [],
      };
    },
    methods: {
      addUser() {
        this.loading = true;

        let payload = {
          username: this.username,
          email: this.email,
          newPassword: this.newPassword,
          roles: [
            {
              name: this.role
            }
          ]
        };

        addAdminUser(payload)
        .then(response => {
          let identityResult = response.data;

          this.errorMessage = '';

          if(identityResult.errors && identityResult.errors.length) {
            identityResult.errors.forEach(error => {
              this.errorMessage += `${error.description}<br>`
            });
          }
          else {
            swal('User Added!', 'Go to the Users route to verify.', 'success');
            this.username = null;
            this.email = null;
            this.newPassword = null;
            this.newPassword2 = null;
            this.role = 'analyst';
            this.$refs.user.reset();
          }
        })
        .finally(() => {
          this.loading = false;
        })
      },
      sortRoles() {
        this.roles.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      },
      /* validateStep(ref) {
        return this.$refs[ref].validate();
      },
      onStepValidated(validated, model) {
        this.wizardModel = { ...this.wizardModel, ...model };
        console.log(this.wizardModel);
      },
      wizardComplete() {
        swal('Good job!', 'You clicked the finish button!', 'success');
      } */
    },
    created() {
      getRoles()
        .then((response) => {
          this.roles = response.data;
          this.sortRoles();
        });
    },
  }
</script>
